import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Button, Form, Badge } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

const ManageUserLogs = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // States
  const [branchOptions, setBranchOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Pagination states
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // Status options
  const statusOptions = [
    { value: 0, label: "Success" },
    { value: 1, label: "Failed" }
  ];

  // Fetch Branches
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${baseURL}/dropdown/branch`);
        if (response.data?.data) {
          const formatted = response.data.data.map(b => ({
            value: b.sno,
            label: `${b.branch_name} (${b.branch_code})`
          }));
          setBranchOptions(formatted);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);

  // Fetch Departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`${baseURL}/dropdown/get_department`);
        if (response.data?.data) {
          const formatted = response.data.data.map(d => ({
            value: d.department_id,
            label: d.department_name
          }));
          setDepartmentOptions(formatted);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartments();
  }, []);

  // Fetch logs whenever page, perPage, or filters change
  useEffect(() => {
    fetchLogs();
  }, [page, perPage]);

  const handleBranchChange = (selected) => setSelectedBranch(selected ? selected.value : null);
  const handleDepartmentChange = (selected) => setSelectedDepartment(selected ? selected.value : null);
  const handleStatusChange = (selected) => setSelectedStatus(selected ? selected.value : null);
  const handleSearchInput = (e) => setSearchText(e.target.value);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        per_page: perPage,
        page,
      };
      if (selectedBranch) params.branch_id = selectedBranch;
      if (selectedDepartment) params.department_id = selectedDepartment;
      if (selectedStatus !== null) params.login_status = selectedStatus;
      if (searchText.trim() !== "") params.search = searchText;

      const response = await axios.get(`${baseURL}/logs/filter`, { params });

      if (response.data?.data) {
        setLogs(response.data.data.data || []);
        setPage(response.data.data.current_page);
        setTotalPages(response.data.data.last_page);
        setTotalCount(response.data.data.total);
      }
    } catch (error) {
      console.error("Error fetching user logs:", error);
    }
    setLoading(false);
  };

  const handleSearch = () => {
    setPage(1);
    fetchLogs();
  };

  const handleClear = () => {
    setSelectedBranch(null);
    setSelectedDepartment(null);
    setSelectedStatus(null);
    setSearchText("");
    setPage(1);
    fetchLogs();
  };

  // return (
  //   <>
  //     {/* Page Title */}
  //     <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
  //       <div className='mb-0'>
  //         <h4 className='breadcrumb-header'>Users Log</h4>
  //         <ol className="breadcrumb fs-7">
  //           <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
  //           <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
  //           <li className="breadcrumb-item active">Monitoring Tools</li>
  //         </ol>
  //       </div>
  //     </div>

  //     {/* Filter Section */}
  //     <div className="row mb-3">
  //       <div className="col-md-2">
  //         <label className="text-black font-w500 fs-7">Branch</label>
  //         <Select
  //           placeholder="Select Branch"
  //           options={branchOptions}
  //           onChange={handleBranchChange}
  //           value={branchOptions.find(opt => opt.value === selectedBranch) || null}
  //         />
  //       </div>
  //       <div className="col-md-2">
  //         <label className="text-black font-w500 fs-7">Department</label>
  //         <Select
  //           placeholder="Select Dept"
  //           options={departmentOptions}
  //           onChange={handleDepartmentChange}
  //           value={departmentOptions.find(opt => opt.value === selectedDepartment) || null}
  //         />
  //       </div>
  //       <div className="col-md-2">
  //         <label className="text-black font-w500 fs-7">Status</label>
  //         <Select
  //           placeholder="Select Status"
  //           options={statusOptions}
  //           onChange={handleStatusChange}
  //           value={statusOptions.find(opt => opt.value === selectedStatus) || null}
  //         />
  //       </div>
  //       <div className="col-md-2">
  //         <label className="text-black font-w500 fs-7">Search</label>
  //         <Form.Control
  //           type="text"
  //           placeholder="Search by IP or username"
  //           value={searchText}
  //           onChange={handleSearchInput}
  //         />
  //       </div>
  //       <div className="col-md-2 d-flex align-items-end justify-content-start gap-2 mt-1">
  //         <Button variant="primary" size="sm" onClick={handleSearch}>Search</Button>
  //         <Button variant="secondary" size="sm" onClick={handleClear}>Clear</Button>
  //       </div>
  //     </div>
  //       {/* Top controls (above table) */}
  //       <div className="d-flex justify-content-between align-items-center mb-2">
  //         {/* Show entries */}
  //         <div>
  //           <label className="me-2">Show</label>
  //           <select
  //             className="form-select d-inline w-auto"
  //             style={{ fontSize: '0.85rem', height: '30px' }}
  //             value={perPage}
  //             onChange={(e) => {
  //               setPerPage(Number(e.target.value));
  //               setPage(1);
  //             }}
  //           >
  //             <option value={10}>10</option>
  //             <option value={25}>25</option>
  //             <option value={50}>50</option>
  //             <option value={100}>100</option>
  //           </select>
  //         </div>

  //         {/* Optional: search bar or filters can go here on right */}
  //         <div>
  //           {/* e.g., Search: <input type="text" /> */}
  //         </div>
  //       </div>

  //     {/* Table */}
  //     <div className='col-lg-12 mb-2'>
  //       <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
  //         <thead>
  //           <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
  //             <th className='min-w-100px'>IP Address</th>
  //             <th className='min-w-100px'>Date/Time</th>
  //             <th className='min-w-100px'>User Name</th>
  //             <th className='min-w-100px'>Password</th>
  //             <th className='min-w-100px'>Login</th>
  //           </tr>
  //         </thead>
  //         <tbody className="text-gray-600 fw-semibold fs-7">
  //           {loading ? (
  //             <tr><td colSpan="5" className="text-center">Loading...</td></tr>
  //           ) : logs.length > 0 ? (
  //             logs.map(log => (
  //               <tr key={log.userlog_id}>
  //                 <td className="text-black">
  //                   <div className='d-flex flex-column align-items-start'>
  //                     <label className='text-black font-w500 fs-7'>{log.ip_address}</label>
  //                     <Badge bg="primary" className='py-1 px-2 fs-7'>
  //                       {log.branch_name || "-"}
  //                     </Badge>
  //                   </div>
  //                 </td>
  //                 <td className="text-black">
  //                   {log.user_date} / {new Date(`1970-01-01T${log.user_time}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
  //                 </td>
  //                 <td className="text-black">{log.user_name}</td>
  //                 {/* <td className="text-black">{log.password ? '*'.repeat(log.password.length) : ''}</td> */}
  //                  <td className="text-black">{log.password}</td>
  //                 <td>
  //                   <Badge
  //                     bg={log.login_status_title === "Success" ? "success" : "danger"}
  //                     className='py-1 px-2 fs-7'
  //                   >
  //                     {log.login_status_title}
  //                   </Badge>
  //                 </td>
  //               </tr>
  //             ))
  //           ) : (
  //             <tr><td colSpan="5" className="text-center">No logs found.</td></tr>
  //           )}
  //         </tbody>
  //       </table>
  //     </div>

  //     {/* Bottom controls (below table) */}
  //     <div className="d-flex justify-content-between align-items-center mt-3">
  //       {/* Showing x to y of z */}
  //       <div>
  //         {logs.length > 0 ? (
  //           <span className="text-muted">
  //             Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + logs.length} of {totalCount} entries
  //           </span>
  //         ) : (
  //           <span className="text-muted">Showing 0 to 0 of 0 entries</span>
  //         )}
  //       </div>

  //       {/* Pagination */}
  //       <nav>
  //         <ul className="pagination justify-content-end mb-0" style={{ fontSize: '0.75rem' }}>
  //           <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
  //             <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
  //           </li>
  //           {[...Array(totalPages)].map((_, i) => (
  //             <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
  //               <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
  //             </li>
  //           ))}
  //           <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
  //             <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
  //           </li>
  //         </ul>
  //       </nav>
  //     </div>
  //   </>
  // );

  return (
  <>
    {/* Page Title */}
 

    <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
    <div className='mb-0'>
      {loading ? (
        <>
          {/* Skeleton for the page title */}
          <h4 className='breadcrumb-header'><Skeleton width={150} /></h4>

          {/* Skeleton for the breadcrumb items */}
          <ol className="breadcrumb fs-7 d-flex gap-1">
            <li className="breadcrumb-item"><Skeleton width={70} /></li>
            <li className="breadcrumb-item"><Skeleton width={20} /></li>
            <li className="breadcrumb-item"><Skeleton width={100} /></li>
          </ol>
        </>
      ) : (
        <>
          <h4 className='breadcrumb-header'>Users Log</h4>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Monitoring Tools</li>
          </ol>
        </>
      )}
    </div>
  </div>


    {/* Filter Section */}
    <div className="row mb-3">
      {/* Branch */}
      <div className="col-md-2">
        {loading ? (
          <>
            <Skeleton width={60} height={15} className="mb-1" />
            <Skeleton height={38} />
          </>
        ) : (
          <>
            <label className="text-black font-w500 fs-7">Branch</label>
            <Select
              placeholder="Select Branch"
              options={branchOptions}
              onChange={handleBranchChange}
              value={branchOptions.find(opt => opt.value === selectedBranch) || null}
            />
          </>
        )}
      </div>

      {/* Department */}
      <div className="col-md-2">
        {loading ? (
          <>
            <Skeleton width={80} height={15} className="mb-1" />
            <Skeleton height={38} />
          </>
        ) : (
          <>
            <label className="text-black font-w500 fs-7">Department</label>
            <Select
              placeholder="Select Dept"
              options={departmentOptions}
              onChange={handleDepartmentChange}
              value={departmentOptions.find(opt => opt.value === selectedDepartment) || null}
            />
          </>
        )}
      </div>

      {/* Status */}
      <div className="col-md-2">
        {loading ? (
          <>
            <Skeleton width={50} height={15} className="mb-1" />
            <Skeleton height={38} />
          </>
        ) : (
          <>
            <label className="text-black font-w500 fs-7">Status</label>
            <Select
              placeholder="Select Status"
              options={statusOptions}
              onChange={handleStatusChange}
              value={statusOptions.find(opt => opt.value === selectedStatus) || null}
            />
          </>
        )}
      </div>

      {/* Search */}
      <div className="col-md-2">
        {loading ? (
          <>
            <Skeleton width={50} height={15} className="mb-1" />
            <Skeleton height={38} />
          </>
        ) : (
          <>
            <label className="text-black font-w500 fs-7">Search</label>
            <Form.Control
              type="text"
              placeholder="Search by IP or username"
              value={searchText}
              onChange={handleSearchInput}
            />
          </>
        )}
      </div>

      {/* Buttons */}
      <div className="col-md-2 d-flex align-items-end justify-content-start gap-2 mt-1">
        {loading ? (
          <Skeleton width={100} height={35} />
        ) : (
          <>
            <Button variant="primary" size="sm" onClick={handleSearch}>Search</Button>
            <Button variant="secondary" size="sm" onClick={handleClear}>Clear</Button>
          </>
        )}
      </div>
    </div>

      {/* Top controls (above table) */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        {/* Show entries */}
        <div>
          {loading ? (
            <div className="d-flex align-items-center gap-2">
              <Skeleton width={50} height={15} />
              <Skeleton width={60} height={28} borderRadius={5} />
            </div>
          ) : (
            <>
              <label className="me-2">Show</label>
              <select
                className="form-select d-inline w-auto"
                style={{ fontSize: '0.85rem', height: '30px' }}
                value={perPage}
                onChange={(e) => {
                  setPerPage(Number(e.target.value));
                  setPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </>
          )}
        </div>

        {/* Optional: right side placeholder for filters or actions */}
        <div>
          {loading && <Skeleton width={120} height={25} borderRadius={5} />}
        </div>
      </div>


    {/* Table */}
    <div className='col-lg-12 mb-2'>
      <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
          <thead>
            {loading ? (
              <tr>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
              </tr>
            ) : (
              <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                <th className='min-w-100px'>IP Address</th>
                <th className='min-w-100px'>Date/Time</th>
                <th className='min-w-100px'>User Name</th>
                <th className='min-w-100px'>Password</th>
                <th className='min-w-100px'>Login</th>
              </tr>
            )}
          </thead>

        <tbody className="text-gray-600 fw-semibold fs-7">
          {loading ? (
            [...Array(perPage)].map((_, i) => (
              <tr key={i}>
                <td><Skeleton /></td>
                <td><Skeleton /></td>
                <td><Skeleton /></td>
                <td><Skeleton /></td>
                <td><Skeleton /></td>
              </tr>
            ))
          ) : logs.length > 0 ? (
            logs.map(log => (
              <tr key={log.userlog_id}>
                <td className="text-black">
                  <div className='d-flex flex-column align-items-start'>
                    <label className='text-black font-w500 fs-7'>{log.ip_address}</label>
                    <Badge bg="primary" className='py-1 px-2 fs-7'>
                      {log.branch_name || "-"}
                    </Badge>
                  </div>
                </td>
                <td className="text-black">
                  {log.user_date} / {new Date(`1970-01-01T${log.user_time}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                </td>
                <td className="text-black">{log.user_name}</td>
                <td className="text-black">{log.password}</td>
                <td>
                  <Badge
                    bg={log.login_status_title === "Success" ? "success" : "danger"}
                    className='py-1 px-2 fs-7'
                  >
                    {log.login_status_title}
                  </Badge>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="5" className="text-center">No logs found.</td></tr>
          )}
        </tbody>
      </table>
    </div>

 

    <div className="d-flex justify-content-between align-items-center mt-3">
      {/* Left Side: Showing entries */}
      <div>
        {loading ? (
          <Skeleton width={180} height={15} />
        ) : logs.length > 0 ? (
          <span className="text-muted">
            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + logs.length} of {totalCount} entries
          </span>
        ) : (
          <span className="text-muted">Showing 0 to 0 of 0 entries</span>
        )}
      </div>

      {/* Right Side: Pagination */}
      <nav>
        {loading ? (
          <div className="d-flex gap-2">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} width={40} height={25} borderRadius={5} />
            ))}
          </div>
        ) : (
          <ul className="pagination justify-content-end mb-0" style={{ fontSize: '0.75rem' }}>
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button
                className="page-link"
                style={{ padding: '0.25rem 0.5rem' }}
                onClick={() => setPage(page - 1)}
              >
                Previous
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                <button
                  className="page-link"
                  style={{ padding: '0.25rem 0.5rem' }}
                  onClick={() => setPage(i + 1)}
                >
                  {i + 1}
                </button>
              </li>
            ))}
            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                style={{ padding: '0.25rem 0.5rem' }}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>
            </li>
          </ul>
        )}
      </nav>
    </div>


  </>
);

};

export default ManageUserLogs;
